// @flow
import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadPlaylistsByFilterAction } from '../../actions/playlist';

export type State = {
  +[key: string]: {|
    +entities: Array<number>,
    +loaded: boolean,
    +loading: boolean,
    +loadedCursors: { +[key: string]: boolean },
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function playlistsByFilter(
  state: State = initialState,
  action: LoadPlaylistsByFilterAction
): State {
  if (action.type === 'FETCH_PLAYLISTS_BY_FILTER' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
